module.exports = __webpack_public_path__ + "static/scale-model-of-the-thoroughbred-center-in-lexington-kentucky-b6e791b7b33817998619b3142fb3d6d6.png";